


import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs, addDoc, doc, updateDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";


const firebaseConfig = {
  apiKey: "AIzaSyB-Klz9Xb5ZiyFUPSO9aPvglx7faOPXqnk",
  authDomain: "eye-care-institute-9e5c7.firebaseapp.com",
  projectId: "eye-care-institute-9e5c7",
  storageBucket: "eye-care-institute-9e5c7.firebasestorage.app",
  messagingSenderId: "76700299844",
  appId: "1:76700299844:web:6cc25e446a9efab89b8211"
};
  

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection, addDoc, doc, updateDoc  };  // Correct export